import { Directive, inject, OnDestroy, OnInit } from '@angular/core';
import { merge, Subscription } from 'rxjs';
import { MenuService } from '../../menu.service';
import { InfoService } from '../../../shared/services/info.service';
import { MenuCommand } from '../../../shared/models/menu-command';
import { delay, map } from 'rxjs/operators';
import { HttpLoadingService } from '../../http-loading.service';
import { RBCheck } from '@lfw/roesberg';
import { SettingsService } from '../../../shared/settings/settings.service';
import { UserInformationService } from '../../user-information.service';
import { ProjectsService } from '../../../projects/projects.service';
import { AppConfig } from '../../../appconfig';
import { LfwRouterService } from '../../../route/lfw-router.service';

@Directive()
export class NavigationBaseComponent implements OnInit, OnDestroy {
  protected menuService = inject(MenuService);
  protected projectsService = inject(ProjectsService);
  protected infoService = inject(InfoService);
  protected httpLoadingService = inject(HttpLoadingService);
  protected settingsService = inject(SettingsService);
  protected userInformationService = inject(UserInformationService);
  protected routerService = inject(LfwRouterService);
  protected config = inject(AppConfig);

  subscription: Subscription = new Subscription();
  _infoText = '';
  loading$ = this.httpLoadingService.loading$.pipe(delay(1));

  ngOnInit(): void {
    this.subscription.add(
      this.infoService.statusUpdated.subscribe((text) => {
        setTimeout(() => (this._infoText = text));
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  get isProjectAvailable(): boolean {
    return this.projectsService.isProjectSelected;
  }

  get projectName(): string {
    return this.projectsService.currentProjectName;
  }

  get infoText(): string {
    return this._infoText;
  }

  get userName(): string {
    const userInfo = this.userInformationService.userInformation;

    if (!userInfo.isEmpty) {
      // return `${userInfo.DisplayName} (${userInfo.LoginName}) - ${userInfo.Department}`;
      return `${userInfo.displayName}`;
    }
    return '-';
  }

  get hasProjectName(): boolean {
    return !RBCheck.isNullOrEmpty(this.projectsService.currentProjectName);
  }

  get hasInfoText(): boolean {
    return !RBCheck.isNullOrEmpty(this._infoText);
  }

  get longVersion() {
    return 'Version ' + this.config.version();
  }
  get shortVersion() {
    return 'V' + this.config.version();
  }

  public get searchButtonVisible(): boolean {
    return false; // return this.webDokuService.isWebDokuSelected && this.settingsService.settings.viewMode.searchInHeader;
  }

  public userCommands$ = this.menuService.rebuilt$.asObservable().pipe(
    map(() => {
      const cmds = [this.menuService.cmdSettings];
      if (this.menuService.cmdDefaultHelp) {
        cmds.push(this.menuService.cmdDefaultHelp);
      }
      if (this.menuService.cmdCustomHelp) {
        cmds.push(this.menuService.cmdCustomHelp);
      }
      cmds.push(this.menuService.cmdSignOff);
      return cmds.filter((command): command is MenuCommand => !!command);
    })
  );

  public get infoCommands(): MenuCommand[] {
    return [];
    //return [this.menuService.cmdInfoHistory, this.menuService.cmdInfoChanged, this.menuService.cmdInfoWebDoku];
  }

  // TODO: (FST) Refactor to real stream
  public availableItems$ = merge(this.projectsService.moreThanOneProjectAvailable$, this.menuService.rebuilt$).pipe(
    map(() => {
      const allCommands = [this.menuService.cmdOrders, this.menuService.cmdOfflineOrders].filter(
        (command) => !!command
      );
      const items: (MenuCommand | undefined)[] = [];
      /*
        if (moreThanOneProjectAvailable) {
          old-items.push(this.menuService.cmdProject);
        }
        */
      items.push(this.menuService.cmdProject);
      const tempItems = allCommands.filter((item) => {
        return !item.needProject || this.projectsService.isProjectSelected;
      });

      for (const item of tempItems) {
        items.push(item);
      }
      return items.filter((command) => !!command);
    })
  );

  showToolTip(): boolean {
    return this.settingsService.settings.viewMode.showTooltips;
  }

  get isMenuVisible(): boolean {
    const visible =
      !this.settingsService.settings.viewMode.isFullScreen &&
      !this.settingsService.RunningInWindowMode() &&
      this.menuService.navigationAllowed;
    if (visible) {
      this.menuService.rebuilt$.next();
    }
    return visible;
  }
}
